import React from 'react'
import Links from './links'
import Items from './items'

const LIST_TYPES_MAP = {
  'list/links': Links,
  'list/items': Items
}

const List = (props) => {
  const Component = LIST_TYPES_MAP[props.editable.type]
  return (
    <Component { ...props }/>
  )
}

export default List
export { List, LIST_TYPES_MAP }


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/list/index.js